module.exports = __webpack_public_path__ + "media/images/icons/search-202a901ecd9c4546ebb1206e9a72b791.svg";